"use client"
import { useEffect, useState } from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"

const MobileHomeFeedback = () => {
  const [padding, setpadding] = useState(0)

  useEffect(() => {
    setpadding((globalThis.window.innerWidth - 24 - 280 + 12) / 2)
  }, [])

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: `${padding}px`, // Adjust this value to show more or less of the sides
  }

  return (
    <div className="my-[64px] overflow-hidden lg_hidden">
      <h2 className="mx-auto mb-[24px] w-[80%] text-center text-[24px] font-[700] leading-[28px] text-title">
        Feedback from Titto community
      </h2>

      <Slider {...settings}>
        <div>
          <div className="mx-[6px]">
            <div className="shadow-highlights flex flex-col items-start rounded-[12px] bg-white p-[16px]">
              <p className="mb-[16px] min-h-[44px] text-left text-left font-[700] leading-[22px] text-title">
                What a fascinating bird-watching experience!
              </p>
              <p className="mb-[24px] min-h-[80px] text-xs leading-[16px] text-[#3E3E3E]">
                I love receiving notifications whenever a new bird visits, and
                the high-resolution camera captures stunning photos that I can
                easily share with my friends.
              </p>
              <div className="flex w-full items-center justify-between">
                <img className="h-[24px] w-auto" src="/icons/five-star.svg" />
                <img
                  className="h-[44px] w-[44px]"
                  src="/images/home-avatar-1.webp"
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="mx-[6px]">
            <div className="shadow-highlights flex flex-col items-start rounded-[12px] bg-white p-[16px]">
              <p className="mb-[16px] min-h-[44px] text-left text-left font-[700] leading-[22px] text-title">
                Incredibly weather -resistant!{" "}
              </p>
              <p className="mb-[24px] min-h-[80px] text-xs leading-[16px] text-[#3E3E3E]">
                It has withstood heavy rain and strong winds without issues. The
                long standby time means I rarely need to recharge it. Overall,
                it's a fantastic addition to my garden.
              </p>
              <div className="flex w-full items-center justify-between">
                <img className="h-[24px] w-auto" src="/icons/five-star.svg" />
                <img
                  className="h-[44px] w-[44px]"
                  src="/images/home-avatar-2.webp"
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="mx-[6px]">
            <div className="shadow-highlights flex flex-col items-start rounded-[12px] bg-white p-[16px]">
              <p className="mb-[16px] min-h-[44px] text-left font-[700] leading-[22px] text-title">
                New world of birds!{" "}
              </p>
              <p className="mb-[24px] min-h-[80px] text-xs leading-[16px] text-[#3E3E3E]">
                Opened my eyes to a whole new world of bird behavior. With its
                AI-powered identification, I've learned to distinguish between
                species I never knew before.
              </p>
              <div className="flex w-full items-center justify-between">
                <img className="h-[24px] w-auto" src="/icons/five-star.svg" />
                <img
                  className="h-[44px] w-[44px]"
                  src="/images/home-avatar-3.webp"
                />
              </div>
            </div>
          </div>
        </div>
      </Slider>
    </div>
  )
}

export default MobileHomeFeedback
